__turbopack_context__.v({
  "container": "Bou90q_container",
  "graph": "Bou90q_graph",
  "shimmer": "Bou90q_shimmer",
});
